import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TimeoutStateService {
    readonly timeoutExpiresAtStorageKey: string = 'timeoutExpiresAt';
    readonly timeoutDurationStorageKey: string = 'timeoutDuration';

    setSharedTimeout(totalTimeout: number): number {
        const expiresAt: number = Date.now() + totalTimeout;
        const currentExpiresAt: number | null = this.getStoredTimeoutExpiresAt();

        localStorage.setItem(this.timeoutDurationStorageKey, totalTimeout.toString());

        if (!currentExpiresAt || expiresAt > currentExpiresAt) {
            localStorage.setItem(this.timeoutExpiresAtStorageKey, expiresAt.toString());
            return expiresAt;
        }

        return currentExpiresAt;
    }

    getStoredTimeoutExpiresAt(): number | null {
        const value: number = Number(localStorage.getItem(this.timeoutExpiresAtStorageKey));
        return Number.isFinite(value) && value > 0 ? value : null;
    }

    getStoredTimeoutDuration(): number | null {
        const value: number = Number(localStorage.getItem(this.timeoutDurationStorageKey));
        return Number.isFinite(value) && value > 0 ? value : null;
    }

    isActiveTimeout(expiresAt: number): boolean {
        return this.getStoredTimeoutExpiresAt() === expiresAt;
    }

    clearTimeoutState(): void {
        localStorage.removeItem(this.timeoutExpiresAtStorageKey);
        localStorage.removeItem(this.timeoutDurationStorageKey);
    }
}
